import "../styles/BlogPage.css";
import { Link } from "react-router-dom";
import Footer from "../../../../../components/Footer/Footer";
import useBlogList from "../hooks/useBlogList";
import FeaturePost from "../components/FeaturedPost";
import LastPost from "../components/LastPost";
import Breadcrumbs from "../../../../../components/Breadcrumbs/Breadcrumbs";

const BlogPage = () => {
  const { data, status, error } = useBlogList();
  if (status === "loading") return <div className="blog-loading">Loading blogs...</div>;
  if (status === "failed") return <div className="blog-error">Error: {error}</div>;

  return (
    <>
      <Breadcrumbs
        paths={[
          {
            label: "Blog",
            to: "",
          },
        ]}
      />
      <div className="blog-container">
        <header className="blog-header">
          <h1>BLOG</h1>
          <p style={{ color: "#625E55" }}>Insights, stories, and updates from our world.</p>
        </header>
        <FeaturePost data={data} Link={Link} />
        <LastPost data={data} Link={Link} />
      </div>
      <Footer />
    </>
  );
};
export default BlogPage;
